import { TDevices } from '@/features/devices/schemas/devices.schemas.ts';
import { DeviceCard } from './device-card.tsx';
import {
  DevicesListFilterCommand,
  DevicesListFilterState,
} from '@/features/devices/components/device-list-filter-command.tsx';
import { useState } from 'react';

export const DevicesList = ({
  devices,
  isLoading,
}: {
  devices: TDevices;
  isLoading: boolean;
}) => {
  const [currentState, setViewFilterState] = useState<DevicesListFilterState>({
    deviceType: 'all',
  });

  const onStateChange = (newState: DevicesListFilterState) => {
    setViewFilterState(newState);
  };

  const filteredDevices = devices?.filter((p) => {
    if (currentState.deviceType !== 'all') {
      return p.type === currentState.deviceType;
    }

    return true;
  });

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <div className="h-[36px] w-[215px] rounded-md bg-white/80"></div>
        <ul className="device-grid grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array(9)
            .fill(() => null)
            .map((_, index) => (
              <li
                key={index}
                className="plant-grid-item h-[165px] overflow-hidden rounded-xl bg-white/80"
              ></li>
            ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <DevicesListFilterCommand currentState={currentState} onStateChange={onStateChange} />
      <ul className="device-grid grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filteredDevices?.map((device) => {
          if (!device.showInDashboard) return null;

          return <DeviceCard key={device.deviceId} device={device} />;
        })}
      </ul>
    </div>
  );
};
